<template>
  <main class="impressum-wrap">
    <!-- Container für den Inhalt der Datenschutzerklärung -->
    <section class="impressum-box">
      <h1>Wetter-Wetter | Datenschutzerklärung</h1>

      <p class="intro">
        Diese Datenschutzerklärung informiert darüber, welche personenbezogenen Daten wir bei der Nutzung
        von <strong>Wetter-Wetter</strong> verarbeiten. Der <strong>Kommentarbereich</strong> ist die in dieser
        Erklärung verwendete Bezeichnung für den öffentlichen Nachrichtenbereich der Webanwendung.
      </p>

      <div class="section">
        <h2>1. Verantwortliche Stelle</h2>
        <p>
          <strong>Wetter-Wetter</strong><br />
          POOSE Dashboard 1<br />
          Kontakt: <a :href="'mailto:' + contactEmail">{{ contactEmail }}</a>
        </p>
        <p>
          Für diese Webanwendung sind die im Impressum genannten Projektbetreiber verantwortlich, soweit
          dort nichts anderes angegeben ist.
        </p>
      </div>

      <div class="section">
        <h2>2. Überblick über die verarbeiteten Daten</h2>
        <p>Je nach Nutzung verarbeiten wir insbesondere folgende Datenkategorien:</p>
        <ul>
          <li><strong>Server- und Zugriffsdaten:</strong> IP-Adresse, Zeitstempel, angefragte Ressourcen, Statuscodes, Browser- und Geräteinformationen, ggf. Referrer.</li>
          <li><strong>Kontodaten:</strong> E-Mail-Adresse, Passwort bzw. Passwort-Hash, Nickname, Profilbild, Kontostand im Spiel, Wett-/Teilnahmedaten.</li>
          <li><strong>Discord-Anmeldedaten:</strong> die von Discord freigegebenen Profilangaben wie E-Mail-Adresse, Benutzername, Profilbild und ggf. Discord-ID.</li>
          <li><strong>Daten im Kommentarbereich:</strong> Kommentartext, Anhänge, Zeitstempel, zugeordnete Nutzerkennung oder anonyme Kennung, IP-Adresse.</li>
          <li><strong>Datei- und Uploaddaten:</strong> hochgeladene Dateien, Dateiname, MIME-Typ, Größe, Upload-Status, Metadaten zur Zuordnung.</li>
          <li><strong>Push-/Benachrichtigungsdaten:</strong> Push-Subscription und technische Zustellinformationen, soweit Benachrichtigungen aktiviert werden.</li>
        </ul>
      </div>

      <div class="section">
        <h2>3. Betrieb der Website, Hosting und Server-Logfiles</h2>
        <p>
          Beim Aufruf der Website werden aus technischen Gründen Verbindungsdaten verarbeitet. Dazu gehören
          insbesondere die IP-Adresse, Datum und Uhrzeit des Zugriffs, aufgerufene Seiten oder Endpunkte,
          übertragene Datenmengen, Statuscodes sowie Browser- und Geräteinformationen. Soweit der Zugriff über
          unseren Proxy oder Webserver läuft, können diese Daten auch dort protokolliert werden.
        </p>
        <p>
          Wir verarbeiten diese Daten, um die Website auszuliefern, Störungen zu erkennen, Sicherheit und
          Missbrauchsschutz zu gewährleisten und den Betrieb nachzuvollziehen.
        </p>
        <p>
          <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an sicherem und
          funktionsfähigem Betrieb).
        </p>
        <p>
          <strong>Speicherdauer:</strong> Logdaten sollten nur so lange gespeichert werden, wie sie für
          Fehlersuche, Sicherheitsanalyse und Missbrauchsabwehr erforderlich sind. Ein kurzer Löschrhythmus
          (z. B. wenige Tage bis wenige Wochen) ist datensparsam; längere Aufbewahrung sollte nur für konkrete
          Sicherheitsvorfälle erfolgen.
        </p>
      </div>

      <div class="section">
        <h2>4. Registrierung, Benutzerkonto und Anmeldung</h2>
        <p>
          Wenn Sie ein Benutzerkonto anlegen oder sich anmelden, verarbeiten wir die dafür erforderlichen Daten,
          insbesondere E-Mail-Adresse und Authentifizierungsdaten. Je nach Kontofunktion speichern wir außerdem
          Nickname, Profilbild, Guthaben im Spiel, Wettteilnahmen und weitere Kontoinformationen.
        </p>
        <p>
          Die Verarbeitung dient der Bereitstellung des Kontos, der Anmeldung, der Verwaltung des Spielguthabens,
          der Teilnahme an Wetten sowie der Zuordnung von Aktionen zu Ihrem Konto.
        </p>
        <p>
          <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung bzw. vorvertragliche
          Maßnahmen) und, soweit erforderlich, Art. 6 Abs. 1 lit. f DSGVO für Kontosicherheit und Missbrauchsschutz.
        </p>
      </div>

      <div class="section">
        <h2>5. Anmeldung mit Discord</h2>
        <p>
          Wenn Sie sich mit Discord anmelden, verwenden wir die von Discord freigegebenen Daten, die für die
          Anmeldung und Kontoverknüpfung erforderlich sind. Dazu gehören nach dem von Ihnen freigegebenen Umfang
          typischerweise E-Mail-Adresse, Benutzername und Profilbild; zusätzlich können technische Kennungen
          verarbeitet werden, soweit sie für den Login- oder Kontoverknüpfungsprozess benötigt werden.
        </p>
        <p>
          Wir nutzen diese Daten, um Ihren Discord-Zugang einem Wetter-Wetter-Konto zuzuordnen, ein bestehendes
          Konto wiederzuerkennen und Profilangaben im Benutzerkonto zu übernehmen.
        </p>
        <p>
          <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO, soweit die Anmeldung und Kontoverknüpfung
          für die Bereitstellung der Anwendung erforderlich ist; ergänzend Art. 6 Abs. 1 lit. f DSGVO für
          Kontosicherheit und Missbrauchsschutz. Soweit Sie im Discord-Login zusätzliche Freigaben erteilen,
          richtet sich der Datenumfang nach dem dort ausgewählten Umfang.
        </p>
        <p>
          Bitte beachten Sie: Für die Nutzung von Discord gelten zusätzlich die Datenschutzbestimmungen von
          Discord. Dabei kann es zu einer Übermittlung an bzw. Verarbeitung durch Discord als eigenständigen
          Anbieter kommen.
        </p>
      </div>

      <div class="section">
        <h2>6. Kommentarbereich</h2>
        <p>
          Im öffentlichen Kommentarbereich können Sie Nachrichten veröffentlichen. Dabei verarbeiten wir den
          Kommentartext sowie technische Informationen, die zur Bereitstellung und Moderation erforderlich sind,
          etwa Zeitstempel, IP-Adresse, technische Browserinformationen, Anhänge und – falls vorhanden – eine
          Nutzerzuordnung oder anonyme Kennung.
        </p>
        <p>
          Falls ein Kommentar ohne Anmeldung abgegeben wird, kann er dennoch mit einer IP-Adresse oder sonstigen
          technischen Kennungen verknüpft sein, um Missbrauch zu verhindern, rechtliche Ansprüche zu prüfen und
          den Kommentarbereich zu betreiben.
        </p>
        <p>
          <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (Betrieb, Moderation, Sicherheit und
          Missbrauchsabwehr). Soweit ein Kommentar Teil eines eingeloggten Nutzerkontos ist, kann zusätzlich
          Art. 6 Abs. 1 lit. b DSGVO einschlägig sein.
        </p>
        <p>
          <strong>Hinweis:</strong> Bitte geben Sie im Kommentarbereich keine besonderen Kategorien
          personenbezogener Daten preis, sofern dies nicht ausdrücklich erforderlich ist.
        </p>
      </div>

      <div class="section">
        <h2>7. Wetten mit Spielgeld</h2>
        <p>
          Die Webanwendung verwendet ausschließlich Spielgeld. Wir verarbeiten dabei Kontostände, Wetteinsätze,
          gewählte Positionen, Wettteilnahmen und die zugehörigen Kennungen der Wetten. Die Daten werden benötigt,
          um die Spielmechanik zu betreiben, Einsätze zu buchen und die Teilnahme an Wetten anzuzeigen.
        </p>
        <p>
          <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO.
        </p>
      </div>

      <div class="section">
        <h2>8. Dateiuploads, Profilbilder und Anhänge</h2>
        <p>
          Soweit Sie Dateien hochladen, verarbeiten wir die hochgeladenen Inhalte sowie die dafür nötigen
          Metadaten, zum Beispiel Dateiname, Dateityp, Größe, Upload-Zeitpunkt und Zuordnung zu einem Konto oder
          einer Kommentarabgabe. Profilbilder können dem jeweiligen Nutzerkonto dauerhaft oder bis zur Änderung
          zugeordnet werden.
        </p>
        <p>
          <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO für funktionsbezogene Uploads und
          Art. 6 Abs. 1 lit. f DSGVO für technische Bereitstellung, Sicherheit und Missbrauchsschutz.
        </p>
      </div>

      <div class="section">
        <h2>9. Push-Benachrichtigungen</h2>
        <p>
          Wenn Sie Browser-Benachrichtigungen aktivieren, speichern wir die dafür erforderliche Push-Subscription
          samt technischer Zustellinformationen. Diese Daten dienen ausschließlich dazu, Benachrichtigungen an den
          von Ihnen genutzten Browser auszuliefern.
        </p>
        <p>
          <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. a DSGVO, soweit Sie Benachrichtigungen aktiv
          einschalten, und Art. 6 Abs. 1 lit. b DSGVO zur technischen Bereitstellung der Funktion.
        </p>
      </div>

      <div class="section">
        <h2>10. Cookies und ähnliche Technologien</h2>
        <p>
          Wir verwenden ein Session-Cookie, um Sie nach dem Login angemeldet zu halten. Dieses Cookie ist für die
          Bereitstellung des angemeldeten Bereichs erforderlich.
        </p>
        <p>
          Nach § 25 Abs. 2 TDDDG ist für die Speicherung oder den Zugriff auf Informationen in Ihrem Endgerät
          keine Einwilligung erforderlich, wenn dies unbedingt erforderlich ist, damit wir den von Ihnen
          gewünschten digitalen Dienst zur Verfügung stellen können.
        </p>
        <p>
          Weitere Cookies oder ähnliche Technologien sollten nur eingesetzt werden, wenn sie technisch notwendig
          sind oder auf einer Einwilligung beruhen.
        </p>
      </div>

      <div class="section">
        <h2>11. Empfänger und Auftragsverarbeiter</h2>
        <p>
          Je nach Funktion können folgende Stellen Daten erhalten oder technisch verarbeiten: Hosting- und
          Infrastruktur-Dienstleister, E-Mail-Dienstleister, Discord als Login- und Profilanbieter, sowie
          gegebenenfalls technische Dienstleister für Benachrichtigungen oder Protokollierung.
        </p>
        <p>
          Soweit Dienstleister in unserem Auftrag handeln, werden sie vertraglich auf Datenschutz und Sicherheit
          verpflichtet.
        </p>
        <p>
          Falls Daten in Drittländer übermittelt werden, geschieht dies nur auf Grundlage der gesetzlichen
          Voraussetzungen der DSGVO.
        </p>
      </div>

      <div class="section">
        <h2>12. Speicherdauer und Löschung</h2>
        <p>Wir speichern personenbezogene Daten nur so lange, wie es für die jeweiligen Zwecke erforderlich ist.</p>
        <ul>
          <li><strong>Logdaten:</strong> kurzzeitig für Betrieb und Sicherheit.</li>
          <li><strong>Konto- und Profildaten:</strong> bis zur Löschung des Kontos oder bis Sie die Daten entfernen lassen.</li>
          <li><strong>Kommentarbereich:</strong> bis zur Löschung des Kommentars, zur Moderation oder bis zum Ende des Projektbetriebs, soweit keine längere Speicherung erforderlich ist.</li>
          <li><strong>Discord-Daten:</strong> solange das Konto mit Discord verknüpft ist bzw. bis zur Löschung des Kontos.</li>
          <li><strong>Upload- und Anhangsdaten:</strong> bis zur Löschung, Sperrung oder projektbezogenen Archivierung.</li>
          <li><strong>Push-Subscriptions:</strong> bis zum Widerruf oder zur Deaktivierung der Benachrichtigungsfunktion.</li>
        </ul>
        <p>
          Gesetzliche Aufbewahrungspflichten bleiben unberührt.
        </p>
      </div>

      <div class="section">
        <h2>13. Ihre Rechte</h2>
        <p>Sie haben im Rahmen der gesetzlichen Voraussetzungen insbesondere folgende Rechte:</p>
        <ul>
          <li>Auskunft über die verarbeiteten Daten,</li>
          <li>Berichtigung unrichtiger Daten,</li>
          <li>Löschung Ihrer Daten,</li>
          <li>Einschränkung der Verarbeitung,</li>
          <li>Datenübertragbarkeit,</li>
          <li>Widerspruch gegen Verarbeitungen auf Grundlage berechtigter Interessen,</li>
          <li>Widerruf erteilter Einwilligungen mit Wirkung für die Zukunft.</li>
        </ul>
        <p>
          Außerdem haben Sie das Recht, sich bei einer Datenschutzaufsichtsbehörde zu beschweren.
        </p>
      </div>

      <div class="section">
        <h2>14. Pflicht zur Bereitstellung der Daten</h2>
        <p>
          Die Bereitstellung bestimmter Daten ist für die Nutzung einzelner Funktionen erforderlich, etwa für die
          Registrierung, den Discord-Login, das Speichern von Kommentaren oder den Versand von Push-Nachrichten.
          Ohne diese Angaben können die jeweiligen Funktionen ganz oder teilweise nicht bereitgestellt werden.
        </p>
      </div>

      <div class="section">
        <h2>15. Keine automatisierte Entscheidungsfindung</h2>
        <p>
          Eine ausschließlich automatisierte Entscheidungsfindung im Sinne von Art. 22 DSGVO findet nach unserem
          derzeitigen Stand nicht statt.
        </p>
      </div>

      <div class="section">
        <h2>16. Datensicherheit</h2>
        <p>
          Wir treffen technische und organisatorische Maßnahmen, um personenbezogene Daten vor Verlust,
          unbefugtem Zugriff und Missbrauch zu schützen. Dazu gehören insbesondere Zugriffsbeschränkungen,
          verschlüsselte Übertragung, Berechtigungsmanagement und eine sparsame Protokollierung.
        </p>
      </div>

      <div class="section">
        <h2>17. Stand dieser Datenschutzerklärung</h2>
        <p>
          <strong>Stand:</strong> {{ standDatum }}
        </p>
      </div>
    </section>
  </main>
</template>

<script>
// Diese Komponente verwendet die Options-API (ältere Vue-Syntax).
export default {
  name: 'PrivacyView',
  data() {
    return {
      contactEmail: 'support@wetter-wetter.de',
      standDatum: '05.06.2026'
    };
  }
};
</script>

<style scoped>
.impressum-wrap {
  display: flex;
  justify-content: center;
  padding: 2rem 1rem;
  min-height: 60vh;
}

.impressum-box {
  background: linear-gradient(180deg, #ffffffcc, #fafafa);
  color: #0b0b0b;
  max-width: 900px;
  width: 100%;
  border-radius: 12px;
  padding: 1.75rem;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.45);
  text-align: left;
}

.impressum-box h1 {
  font-size: 1.5rem;
  margin-bottom: 0.75rem;
}

.impressum-box h2 {
  font-size: 1.05rem;
  margin-top: 1rem;
  margin-bottom: 0.4rem;
}

.section {
  margin-bottom: 0.95rem;
}

.intro,
.impressum-box p,
.impressum-box ul {
  margin: 0.35rem 0;
  line-height: 1.55;
}

.impressum-box ul {
  padding-left: 1.15rem;
}

.impressum-box a {
  color: #0a58e6;
  text-decoration: none;
}

.impressum-box a:hover {
  text-decoration: underline;
}
</style>
